var _circle, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearAntiStaticBoots50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.838,32 11,32 11,36 19,36 19,34.054 24.838,36 25,36 38,36 38,34 24.838,34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,25c-2.761,0-5-2.239-5-5v-9H12c0,0,0,8,0,11c0,4-1,3-1,8h8l6,2h13C38,28.134,34.866,25,31,25z M23,20c0,0.741-0.215,1.425-0.566,2.02l-5.454-5.454C17.575,16.215,18.259,16,19,16C21.209,16,23,17.791,23,20z M15,20 c0-0.741,0.215-1.425,0.566-2.02l5.454,5.454C20.425,23.785,19.741,24,19,24C16.791,24,15,22.209,15,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearAntiStaticBoots50);
export default __webpack_public_path__ + "static/media/icons8-wear-anti-static-boots-50.8afbd96849154a2375fe27707a2c69af.svg";
export { ForwardRef as ReactComponent };